export default {
  login: {
    title: '加油站容积表数据服务平台',
    logIn: '登 录',
    ver: 'Ver1.1版权所有（C）2018-2025',
    oket: '青岛澳科软件有限责任公司',
    log_fail: '登录失败',
    username: '用户名',
    password: '密码',
    input: '请输入用户名',
    input_pass: '请输入密码'
  },
  route: {
    首页: '首页',
    限额管理: '限额管理',
    报警值管理: '报警值管理',
    账户管理: '账户管理',
    组织管理: '组织管理',
    角色管理: '角色管理',
    功能管理: '功能管理',
    用户管理: '用户管理'
  },
  navbar: {
    pwd_tip: '您的密码强度太低，请尽快修改密码',
    updatepPwd: '修改密码',
    update_photo: '修改头像',
    logOut: '退出登录',
    username: '用户名',
    oldPwd: '原始密码',
    newPwd: '新密码',
    choose: '可选择',
    confirmNewPwd: '确认新密码',
    input_old_pwd: '请输入原始密码',
    pwdDifference: '两次输入密码不一致',
    inPutNewPwd: '请输入新密码',
    inPutPwd: '请输入密码',
    pwdValid: '请输入不少于6位的密码',
    update_success: '修改成功,请重新登录',
    update_fail: '修改失败',
    right_image: '请上传正确的图片格式（jpge/jpg/png/gif）',
    over_image: '图片大小超过1M，请重新选择',
    change_image_name: '图片命名中包含特殊字符，请规正命名再上传',
    choose_image: '请选择头像上传',
    image_success: '更改头像成功',
    image_fail: '更改头像失败',
    menu_search: '菜单查询',
    totalLimit: '总额度',
    usedLimit: '已使用',
    underwayLimit: '进行中',
    residualLimit: '剩余额度'
  },
  table: {
    cancel: '取消',
    confirm: '确认',
    actions: '操作',
    edit: '编辑',
    open: '启用中',
    close: '禁用中',
    edit_menu: '编辑菜单',
    edit_function: '编辑功能',
    add_function: '添加功能',
    changeOpen: '您已修改状态为 --> 停用',
    changeClose: '您已修改状态为 --> 启用',
    add_success: '添加成功',
    add_fail: '添加失败',
    edit_success: '编辑成功',
    edit_fail: '编辑失败',
    choose: '请选择',
    status: '状态',
    del: '删除',
    set_column: '设置列'
  },
  function: {
    fun: '功能',
    write_fun_name: '请输入功能名称',
    fun_name: '功能名',
    write_fun: '请输入功能',
    fun_url: '功能url',
    write_fun_url: '请输入功能url',
    is_menu: '菜单/功能',
    menu: '菜单',
    write_menu: '请输入菜单',
    menu_name: '菜单名',
    write_menu_name: '请输入菜单名',
    is_choose: '是否必选',
    add_menu: '添加菜单',
    edit_menu: '编辑菜单',
    parent_menu: '父级菜单',
    yes: '是',
    no: '否',
    able: '启用',
    disable: '禁用',
    add_function: '添加功能',
    edit_function: '编辑功能',
    status_change_fail: '状态修改失败',
    choose_fun: '请选择功能'
  },
  button: {
    search: '查询',
    add: '添加',
    refresh: '刷新数据'
  },
  org: {
    org_name: '组织',
    org_parent_name: '父级组织',
    write_org_name: '请输入组织名称',
    type: '类型',
    address: '地址',
    add_org: '添加组织',
    edit_org: '编辑组织',
    name: '名称',
    org_name_exist: '该组织名称已存在',
    failTopOrgList: '获取组织根节点列表失败',
    choose_org: '请选择组织'
  },
  role: {
    role: '角色',
    write_role_name: '请输入角色名称',
    number: '序号',
    number_enter: '请输入序号',
    number_empty: '序号不能为空',
    number_num: '序号必须为正数',
    owning_organization: '所属组织',
    name: '名称',
    organization: '组织',
    write: '请输入',
    able: '启用',
    disable: '禁用',
    add_role: '添加角色',
    edit_role: '编辑角色',
    role_del: '该角色将被删除, 是否继续?',
    del_successfully: '删除成功',
    del_fail: '删除失败'
  },
  user: {
    user_name: '用户名',
    role_name: '角色',
    write_user_name: '输入用户名',
    remakes_password: '重置密码',
    nickname: '姓名',
    password: '密码',
    confirm_password: '确认密码',
    email: '邮箱',
    space: '用户名中不能有空格',
    less_name: '请输入不少于4位的用户名',
    exist_user_name: '该用户名已存在',
    write_nickname: '请输入姓名',
    write_password: '请输入密码',
    sure_password: '请确认密码',
    inconsistent_password: '两次填写的密码不一致',
    select_org: '请选择组织',
    select_role: '请选择角色',
    write_email: '请输入正确的邮箱地址',
    createTime: '创建时间',
    updateTime: '最近修改时间',
    loginTime: '最近登录时间',
    add_user: '添加用户',
    search_error: '查询失败',
    reset: '此操作将重置密码为',
    is_continue: ', 是否继续?',
    reset_successfully: '重置成功',
    reset_fail: '重置失败',
    reset_cancle: '已取消重置'
  },
  home: {
    please_enter: '请输入',
    please_select: '请选择',
    cancle: '取 消',
    confirm: '确 定',
    save: '保 存',
    back: '返 回',
    stationName: '加油站名称',
    tankCode: '罐号',
    oilType: '油品',
    formStatus: '状态',
    submit: '提交',
    detail: '详情',
    withdraw: '撤销',
    refutation: '打回',
    download: '下载',
    upload: '上传',
    basic_information: '基础信息',
    flowmeterNo: '流量计编号',
    tankVolume: '罐容',
    tankDiameter: '油罐直径',
    data_recording: '数据记录',
    order: '序号',
    manualHeight: '手工高度',
    levelGaugeHeight: '液位仪高度',
    liquidLevelMeterTemperature: '液位仪温度',
    flowmeterVolume: '流量计体积',
    flowmeterTemperature: '流量计温度',
    alarmValues: '报警值',
    alarmValuesDescription: '报警值说明',
    capture: '打回',
    capture_reason: '打回原因',
    submit_time: '提交时间',
    tabulation_time: '预计出表时间',
    drag_file: '将文件拖到此处，或',
    click_upload: '点击上传',
    limit_upload: '只能上传xlsx/xls文件，且不超过500kb',
    limit_files: '当前限制选择 1 个文件',
    select_file: '请选择文件',
    file_upload_successfully: '文件上传成功',
    file_upload_failure: '文件上传失败',
    gasoline: '汽油',
    diesel_oil: '柴油',
    to_be_submitted: '待提交',
    pending_acceptance: '待受理',
    process_acceptance: '受理中',
    have_completed: '已完成',
    delete: '已作废',
    called_back_reason: '请输入打回原因',
    confirm_commit: '确认提交此数据？',
    tip: '提示',
    submitted_successfully: '提交成功，预计出表时间72小时',
    submission_failure: '提交失败',
    confirm_undo: '确认撤销此数据？',
    undo_successfully: '撤销成功',
    undo_failure: '撤销失败',
    capture_successfully: '打回成功',
    capture_failure: '打回失败',
    del: '作废',
    del_reason: '作废原因',
    enter_del_reason: '请输入作废原因',
    del_successfully: '作废成功',
    del_failure: '作废失败',
    list_fail: '获取数据失败',
    alarm_fail: '获取报警项列表失败',
    customer_download: '容积表下载',
    validateTankCode: '罐号请输入正整数',
    validateTankVolume: '罐容请输入正数',
    validateTankDiameter: '油罐直径请输入正数',
    tankCodeNum: '罐号不能超过127',
    excel_download: 'excel 格式下载',
    txt_download: 'txt 格式下载'
  },
  quota: {
    quota_num: '限额数量',
    quota_enter: '请输入限额数量',
    quota_compare: '限额数量不能小于已使用额度',
    quota_edit: '修改限额',
    quota_used: '已使用额度',
    quota_all: '总额度',
    updateTime: '修改时间'
  },
  alarm: {
    del: '作废',
    explain_zh: '报警说明(中文)',
    explain_zh_enter: '请输入报警说明(中文)',
    explain_en: '报警说明(英文)',
    explain_en_enter: '请输入报警说明(英文)',
    explain_ar: '报警说明(阿拉伯文)',
    explain_ar_enter: '请输入报警说明(阿拉伯文)',
    photo: '照片',
    del_successfully: '作废成功',
    del_fail: '作废失败',
    del_tip: '将作废该数据, 是否继续?',
    cancle_tip: '已取消本次操作',
    jpg: '上传图片只能是 JPG 格式',
    jpg_size: '上传图片大小不能超过 2MB'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js